import VideoCard from './VideoCard'

export default VideoCard
